module.exports = __webpack_public_path__ + "static/media/IMG_9218-2.933c254c.jpg";